module.exports = __webpack_public_path__ + "static/banner-four-shape7-3fe9775b36b8bbee22b685297ee4ab91.png";